export enum VersionedFileEntityType {
    CenterDonorAgreement = 1,
    CenterRecipientAgreement = 2,
    CenterContract = 3,
    CenterGraftSurvival = 4,
    CenterPatientSurvival = 5,
    CenterAllInAgreement = 6,
    CenterBaaFile = 7,
    CenterDonorProtectionAddendum = 8,
    CenterPartnerCenterAgreement = 9,
    CenterDCNAgreement = 10,
    CenterDonorShieldAgreement = 11,
    CenterTaxExemptionCertificate = 12,
    CenterContractAddendum = 13,
    CenterPoDocument = 14,
    W9 = -1,
    Cms = -2
}
